module.exports = __webpack_public_path__ + "img/analytic120 1.2a9d46cc.svg";